interface PropsTitle {
    title?: string
    subtitle?: React.ReactNode
}
export function Title({ subtitle, title }: PropsTitle) {
    return (
        <div>
            <div className="flex gap-2">
                <h2 className="text-lg font-semibold text-gray-700">Contas </h2>
                <h2 className="text-lg font-semibold text-gray-400">{title}</h2>
            </div>
            <h3 className="text-sm font-semibold text-gray-700">{subtitle}</h3>
        </div>
    )
}